import { render, staticRenderFns } from "./permission-config.vue?vue&type=template&id=6ae5b06d&scoped=true"
import script from "./permission-config.vue?vue&type=script&lang=js"
export * from "./permission-config.vue?vue&type=script&lang=js"
import style0 from "./permission-config.vue?vue&type=style&index=0&id=6ae5b06d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5b06d",
  null
  
)

export default component.exports